import type { ReactNode } from "react";
import { truncationMarkerProps } from "@/components/table/truncationCell";
import styles from "./FilterResultChip.module.css";

export type FilterResultChipProps = {
  // 조건 표기다("작업: Multi Task" 등). 문구 조립은 호출자가 소유한다.
  label: string;
  // ✕ 버튼의 접근성 이름("… 해제")이다. 시각 라벨과 분리해서 해제 대상을 읽어 준다.
  removeLabel: string;
  onRemove: () => void;
  disabled?: boolean;
};

/**
 * 적용 중인 조회 조건 한 개를 나타내는 칩이다. 라벨과 ✕(그 조건만 해제)를 가진다.
 *
 * 조건 칩의 시각 계약을 한 곳에 둔다:
 * - 파랑 filled 로 활성 조건임을 표시한다.
 * - 높이는 1.75rem 이다(c6 sm 컨트롤 정렬).
 * - ✕ 는 칩 내부에 두어 호버 영역이 칩 밖으로 나가지 않게 한다. 칩과 형제 버튼을 나란히 두면
 *   버튼 높이(1.75rem)가 칩보다 커져서 호버 배경이 맞지 않는다.
 * 데이터셋 필터 레일·고급 필터 시트 프리뷰·학습 세션 필터 바가 함께 쓴다.
 */
export function FilterResultChip({
  label,
  removeLabel,
  onRemove,
  disabled = false,
}: FilterResultChipProps): ReactNode {
  return (
    <span className={styles.chip}>
      <span className={styles.label} {...truncationMarkerProps}>
        {label}
      </span>
      <button
        type="button"
        className={styles.remove}
        aria-label={removeLabel}
        disabled={disabled}
        onClick={onRemove}
      >
        ✕
      </button>
    </span>
  );
}
